module.exports = __webpack_public_path__ + "img/gpt-addin-03.51b991a9.png";